import { Flex, Popover } from 'core-ui';
import { AvatarIcon, DownOutlinedIcon, MenuFoldIcon } from 'src/assets/icons';
import { useContext } from 'react';
import { ProfileContext } from 'src/contexts/profile';
import { handleAdminLogout } from 'src/services/auth';

interface HeaderProps {
  handleOpenDrawer?: () => void;
}

const Header: React.FC<HeaderProps> = ({ handleOpenDrawer }) => {
  const { profile } = useContext(ProfileContext);

  return (
    <div className="h-full flex items-center justify-between min-[821px]:justify-end px-5 bg-primary">
      <Flex align="center" className="min-[821px]:hidden">
        <button onClick={handleOpenDrawer}>
          <img src={MenuFoldIcon} alt="menu fold icon" />
        </button>

        <h1 className="ml-7 text-xl truncate">GBase 管理画面</h1>
      </Flex>
      <div className="hidden min-[821px]:flex items-center">
        <Popover
          placement="bottomRight"
          content={
            <div className="min-w-[70px]">
              <p
                onClick={handleAdminLogout}
                className="cursor-pointer w-full text-custom-error10 text-xs text-center"
              >
                ログアウト
              </p>
            </div>
          }
        >
          <div className="flex cursor-pointer items-center">
            <div>
              <img src={AvatarIcon} alt="avatar icon" />
            </div>

            <div className="ml-3">
              <p
                className="leading-5 font-medium text-white max-w-80 truncate"
                title={profile?.name}
              >
                {profile?.name}
              </p>
            </div>

            <div className="ml-2">
              <img src={DownOutlinedIcon} alt="down outlined icon" />
            </div>
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default Header;
